/**
 * Generic chart color system — self-contained, theme-independent.
 *
 * Charts always render with their own background and Figma color scheme,
 * regardless of the app's light/dark theme.
 */

const E = {
  // ─── Data Colors (chart fills, strokes, segments) ───
  /** Primary chart color — bar fills, line strokes */
  cyan: "#036263",
  /** Secondary chart color — series B, comparison bars */
  orange: "#D97757",
  /** Accent 3 */
  olive: "#C5B358",
  /** Accent 4 */
  brown: "#5B4D3A",
  /** Accent 5 */
  green: "#3A7D4F",
  /** Accent 6 */
  yellow: "#D4C873",
  /** Accent 7 */
  purple: "#6B5DA6",

  // ─── Text Colors (from Figma: base #01262b with opacity) ───
  /** Primary text — legend values, strong labels */
  t1: "#01262b",
  /** Secondary text — in-bar value labels */
  t2: "rgba(1, 38, 43, 0.8)",
  /** Tertiary text — chart title, data point labels */
  t3: "rgba(1, 38, 43, 0.6)",
  /** Quaternary text — axis labels, grid text */
  muted: "rgba(1, 38, 43, 0.4)",

  // ─── Background / Structure ───
  /** Chart background */
  bgPage: "#f9f9f3",
  /** Grid lines */
  chartGrid: "rgba(1, 38, 43, 0.08)",
  /** Subtle border */
  borderSubtle: "rgba(1, 38, 43, 0.1)",
} as const;

export { E };

/**
 * Chart data palette — ordered color cycle for multi-item charts.
 * Colors chosen for good contrast on the chart's light background (#f9f9f3).
 */
const CHART_PALETTE = [
  E.cyan,
  E.orange,
  E.olive,
  E.brown,
  E.green,
  E.yellow,
  E.purple,
];

/** Get chart color by index — cycles through the palette */
export function getChartColor(index: number): string {
  return CHART_PALETTE[index % CHART_PALETTE.length];
}
